import { isMasurenPortal } from '~/utils/isMasurenPortal'
import type { TranslationMap } from '~/composables/useTranslations'

// After the homepage has rendered, drop every translation key that no
// component read. The client fills the dictionary back in after idle, so
// later navigation still has the strings, but they are not in the first HTML.
export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const path = route.path
  const { currentPortal } = usePortals()
  const portalId = currentPortal.value?.portal?.portal

  nuxtApp.hook('app:rendered', () => {
    if (!import.meta.server || path !== '/' || !isMasurenPortal(portalId)) {
      return
    }

    nuxtApp.runWithContext(() => {
      const translations = useState<TranslationMap|null>('i18n-translations')
      const usedKeys = useState<Record<string, Record<string, true>>>('i18n-used-keys')
      if (!translations.value || !usedKeys.value) {
        return
      }

      const trimmed: TranslationMap = {}
      for (const [domain, keys] of Object.entries(usedKeys.value)) {
        const source = translations.value[domain]
        if (!source) {
          continue
        }
        const kept: Record<string, string> = {}
        for (const key of Object.keys(keys)) {
          if (source[key] !== undefined) {
            kept[key] = source[key]
          }
        }
        if (Object.keys(kept).length > 0) {
          trimmed[domain] = kept
        }
      }
      translations.value = trimmed
      usedKeys.value = {}
    })
  })

  if (import.meta.client) {
    const { currentPortal } = usePortals()
    const route = useRoute()
    if (!isMasurenPortal(currentPortal.value?.portal?.portal) || route.path !== '/') {
      return
    }
    const { ensureFullTranslations } = useTranslations('nothing')
    onNuxtReady(() => {
      const fill = () => {
        ensureFullTranslations()
      }
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(fill)
      } else {
        setTimeout(fill, 1500)
      }
    })
  }
})
